import { gql, useMutation } from '@apollo/client'

interface Result {
  uncancelStoreOrder: boolean
}

interface Form {
  id: string
}

const mutation = gql`
  mutation UncancelStoreOrder($id: ID!) {
    uncancelStoreOrder(id: $id)
  }
`

const useUncancelStoreOrder = () => {
  const [mutate] = useMutation<Result, Form>(mutation)
  return (variables: Form) => mutate({ variables })
}

export default useUncancelStoreOrder
